import { MESSAGE } from './message.actions';

export function messageMiddleware(uToast) {
  'ngInject';
  return () => next => action => {
    const { type, payload } = action;

    switch (type) {
      case MESSAGE.SUCCESS:
        return uToast.success(payload);

      case MESSAGE.ERROR:
        return uToast.error(payload);
    }

    return next(action);
  };
}
